export class WebConstants {
    static readonly stripeTestKey = 'pk_test_KPoCfZXu7mznb9uSCPZ2JpTD';
    static readonly stripeLiveKey = 'pk_live_bpN0P37nMxrMQkcaHXtAybJk';
    static readonly btSandboxKey = 'sandbox_r72q8jq6_9pnxkwm75f87sdc2';
    static readonly btProductionKey = 'production_qfbsv8kc_njj2zjtyngtjmbjd';
    static readonly paypal = {
        businessIdProduction: '4ZDA7DLUUJGMN',
        businessIdSandbox: 'AD3LAUZSNVPJY',
        buttonActionProduction: 'https://www.paypal.com/cgi-bin/webscr',
        buttonActionSandbox: 'https://www.sandbox.paypal.com/cgi-bin/webscr',
    };
}
